import React from 'react';
import Modal, { ModalProps } from 'shared/lib/components/modals/modal';

export default function DesktopSmallModal({
  children,
  ...other
}: {
  children: React.ReactNode;
} & ModalProps) {
  return (
    <Modal {...other} maxWidth="desktop_small">
      {children}
    </Modal>
  );
}
